<ion-app>
  <app-menu></app-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
